import {
  EntityList,
  EntityListProps,
  renderInvertedYesNoIcon,
  renderYesNoIcon,
} from 'components/EntityList'
import { Worker } from 'model'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn, FieldColumn } from 'views/helpers'

const qColumnProps: Partial<FieldColumn> = {
  minWidth: 50,
  maxWidth: 50,
  onRender: renderYesNoIcon,
  ungroupable: true,
}
const qLargeColumnProps = {
  ...qColumnProps,
  maxWidth: 80,
}

export type WorkerListProps = EntityListProps<Worker>

export const WorkerList: React.FunctionComponent<WorkerListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={[
        fieldColumn('inactive', {
          minWidth: 40,
          maxWidth: 40,
          name: t('field.active.label'),
          onRender: renderInvertedYesNoIcon,
          ungroupable: true,
        }),
        fieldColumn('name', {
          minWidth: 100,
          maxWidth: 125,
          copyText: true,
        }),
        fieldColumn('lastName', {
          minWidth: 75,
          maxWidth: 100,
          isSorted: true,

          copyText: true,
        }),
        fieldColumn('firstName', {
          minWidth: 75,
          maxWidth: 100,
          copyText: true,
          ungroupable: true,
        }),
        fieldColumn('pid', {
          copyText: true,
          ungroupable: true,
          onRender: (item: Worker) => item._id,
        }),
        fieldColumn('company', { copyText: true }),
        fieldColumn('department', { copyText: true }),
        fieldColumn('qBasic', qColumnProps),
        fieldColumn('qTurbo', qColumnProps),
        fieldColumn('qSupersport', qLargeColumnProps),
        fieldColumn('qNordschleife', qLargeColumnProps),
        fieldColumn('qMuLow', qColumnProps),
        fieldColumn('qOffroad', qColumnProps),
        fieldColumn('annotation', { maxWidth: undefined, ungroupable: true }),
      ]}
      {...props}
    />
  )
}
